import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=a2abc53e&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2abc53e",
  null
  
)

export default component.exports